import { actionCreatorFactory } from "typescript-fsa";

const factory = actionCreatorFactory("MODULF");

export const lockProcess = factory<LockProcessPayload>("LOCK_PROCESS");

export const unlockProcess = factory<LockProcessPayload>("UNLOCK_PROCESS");

export const renewLockProcess = factory<LockProcessPayload>("RENEW_LOCK_PROCESS");

export const lockProcessError = factory<LockProcessPayload>("LOCK_PROCESS_ERROR");

export const startLockProcessPolling = factory<LockProcessPayload>("START_LOCK_PROCESS_POLLING");

export const stopLockProcessPolling = factory<LockProcessPayload>("STOP_LOCK_PROCESS_POLLING");

export interface LockProcessPayload {
	docRef?: string;
}
